
/**
 * Calculate quiz session statistics from an array of sessions
 * Returns pass count, fail count, average score, pass rate, fail rate, total correct, and total questions
 * @param {Array} sessions - Array of quiz session objects
 * @returns {Object} Statistics object with metrics
 */
export const calculateQuizStats = (sessions) => {
  if (!sessions || sessions.length === 0) {
    return {
      passCount: 0,
      failCount: 0,
      avgScore: 0,
      passRate: 0,
      failRate: 0,
      totalCorrect: 0,
      totalQuestions: 0,
    };
  }

  let passCount = 0;
  let totalScore = 0;
  let totalCorrect = 0;
  let totalQuestions = 0;

  sessions.forEach((session) => {
    const score =
      session.total_question_count > 0
        ? Math.round(
          (session.correct_answer_count / session.total_question_count) *
          100
        )
        : 0;

    if (score >= 50) {
      passCount++;
    }

    totalScore += score;
    totalCorrect += session.correct_answer_count || 0;
    totalQuestions += session.total_question_count || 0;
  });

  const avgScore =
    sessions.length > 0 ? Math.round(totalScore / sessions.length) : 0;
  const failCount = sessions.length - passCount;

  const passRate =
    totalQuestions > 0 ? Math.round((totalCorrect / totalQuestions) * 100) : 0;
  const failRate = 100 - passRate;

  return {
    passCount,
    failCount,
    avgScore,
    passRate,
    failRate,
    totalCorrect,
    totalQuestions,
  };
};

export const downloadCSV = (quizData, sessions) => {
  if (sessions.length === 0) {
    alert("No data to download")
    return
  }

  // CSV headers
  const headers = [
    "Student Name",
    "Mat No",
    "Email",
    "User Type",
    "Score",
    "Total Questions",
    "Percentage",
    "Started At",
    "Completed At",
    "Duration (minutes)",
    "Course",
    "Course Code",
    "Topic",
  ]

  // Convert sessions to CSV rows
  const csvRows = sessions.map((session) => {
    const startTime = new Date(session.started_at)
    const completedTime = session.completed_at ? new Date(session.completed_at) : null
    const duration = completedTime ? Math.round((completedTime - startTime) / (1000 * 60)) : "Incomplete"
    const percentage =
      session.total_question_count > 0
        ? Math.round((session.correct_answer_count / session.total_question_count) * 100)
        : 0

    const matNo =
      session.user_detail?.mat_no ||
      session.student_details?.mat_no ||
      "N/A"

    return [
      `${session.user_detail.first_name} ${session.user_detail.last_name}`,
      matNo,
      session.user_detail.email,
      session.user_detail.user_type || "student",
      session.correct_answer_count ?? 0,
      session.total_question_count ?? 0,
      `${percentage}%`,
      startTime.toLocaleString(),
      completedTime ? completedTime.toLocaleString() : "Not completed",
      duration,
      session.topic_detail?.course_detail?.title || quizData?.topic_detail?.course_detail?.title || "N/A",
      session.topic_detail?.course_detail?.code || quizData?.topic_detail?.course_detail?.code || "N/A",
      session.topic_detail?.title || quizData?.topic_detail?.title || "N/A",
    ]
  })

  // Create CSV content
  const csvContent = [headers, ...csvRows].map((row) => row.map((field) => `"${field}"`).join(",")).join("\n")

  // Create and download file
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
  const link = document.createElement("a")
  const url = URL.createObjectURL(blob)
  link.setAttribute("href", url)
  link.setAttribute(
    "download",
    `quiz-results-${quizData?.topic_detail?.title?.replace(/\s+/g, "-").toLowerCase() || "quiz"}-${new Date().toISOString().split("T")[0]}.csv`,
  )
  link.style.visibility = "hidden"
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


